import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { BanThanhPhamModel } from '../ban-thanh-pham-model/ban-thanh-pham.model';
const API_ROOT_URL = environment.ApiRoot + '/hanghoa';
@Injectable()
export class BanThanhPhamService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(
		private http: HttpClient,
		private httpUtils: HttpUtilsService
	) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DM_Hanghoa_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getBanThanhPhamById(itemId: any): Observable<any> {
		return this.http.get<any>(API_ROOT_URL + `/DM_HangHoa_Detail?Id_HH=${itemId}`);
	}
	deleteBanThanhPham(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DM_HangHoa_Delete?Id_HH=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	deleteBanThanhPhams(ids: any[] = []): Observable<any> {
		const url = API_ROOT_URL + '/DM_HangHoa_Multi_Delete';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QueryResultsModel>(url, ids, { headers: httpHeaders} );
	}
	createBanThanhPham(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		let data = this.convertItemToServerType(item);
		return this.http.post<BanThanhPhamModel>(API_ROOT_URL+'/DM_HangHoa_Insert', data, { headers: httpHeaders });
	}
	updateBanThanhPham(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		let data = this.convertItemToServerType(item);
		return this.http.post<BanThanhPhamModel>(API_ROOT_URL+'/DM_HangHoa_Update', data, { headers: httpHeaders });
	}
	updateBanThanhPhamDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		let data = this.convertItemToServerType(item);
		return this.http.post<BanThanhPhamModel>(API_ROOT_URL+'/DM_HangHoa_Update_Detail', data, { headers: httpHeaders });
	}
	uploadFileBanThanhPham(data): Observable<any> {
		const url = API_ROOT_URL + '/DM_HangHoa_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	importBanThanhPham(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<BanThanhPhamModel>(API_ROOT_URL+'/DM_HangHoa_Import', item, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + `/DownLoadFileImportMau`;
	}
	listId_NhomHH(itemId: any) : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  API_ROOT_URL + `/DM_NhomHangHoa_List?idLoaiHH=${itemId}` ;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listDVT1() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_DVT_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listBoPhanKiemTra() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_PhongBan_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	convertItemToServerType(item: BanThanhPhamModel) {
        let rs: any = {};
        Object.assign(rs, item);

        return rs;
	}
	downloadTCNPL(itemId: any): string {
		return API_ROOT_URL + `/DownLoadFileTieuChuanNPL?id=${itemId}`;
	}

	listDongSanPham() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_DongSanPham_List?idloaihh=5' ;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
}
